import SearchBarCloseIcon from 'src/refactor_components/common/SearchBarCloseIcon';

interface Props {
  setColumnModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ColumnModal = ({ setColumnModalOpen }: Props) => {
  return (
    <div>
      <div className="flex justify-end w-full">
        <SearchBarCloseIcon onClick={() => setColumnModalOpen(false)} />
      </div>
      <div className="flex flex-col gap-34">
        <div className="flex flex-col gap-21">
          <h1 className="font-semibold text-[20px] text-[#C9C7D1] text-center">
            피벗 튜터 신청하기
          </h1>
          <span className="text-[14px] font-medium text-[#C9C7D1]">
            피벗 튜터로 선정된 전문가만 칼럼 작성이 가능해요
          </span>
        </div>
        <div className="flex w-full gap-12">
          <button
            onClick={() => setColumnModalOpen(false)}
            className="bg-[#24222A] w-full  h-46   rounded-8  px-40 py-12 text-center text-[14px]"
          >
            취소
          </button>
          <a
            href="https://walla.my/v/elknFURvG2XebeaJQF44"
            target="_blank"
            className="bg-[#7750E9]  w-full  h-46   rounded-8 px-40 py-12 text-center text-[14px] text-[#EAE8ED] leading-22 font-medium tracking-[-0.425px]"
          >
            신청하기
          </a>
        </div>
      </div>
    </div>
  );
};

export default ColumnModal;
